import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader, Card, StatusPill } from '@/components/Primitives';
import { Plus, Trash } from '@phosphor-icons/react';
import { Modal, Field } from './Extensions';
import { useToast } from '@/hooks/use-toast';

const ROLES = ['admin', 'voice_manager', 'read_only'];

const Users = () => {
    const [items, setItems] = useState([]);
    const [editing, setEditing] = useState(null);
    const { toast } = useToast();

    const load = async () => {
        const r = await api.get('/auth/users');
        setItems(r.data);
    };
    useEffect(() => { load(); }, []);

    const save = async (e) => {
        e.preventDefault();
        try {
            await api.post('/auth/users', editing);
            setEditing(null); load();
            toast({ title: 'Uloženo' });
        } catch (err) {
            toast({ title: 'Chyba', description: err.response?.data?.detail || 'error', variant: 'destructive' });
        }
    };
    const del = async (id) => {
        if (!window.confirm('Smazat uživatele?')) return;
        await api.delete(`/auth/users/${id}`); load();
    };

    return (
        <>
            <PageHeader
                eyebrow="Access Control"
                title="CMS Uživatelé"
                description="Správa přístupů: admin, voice_manager, read_only. Role jsou enforced backendem."
                actions={
                    <button onClick={() => setEditing({ email: '', name: '', password: '', roles: ['voice_manager'] })}
                            className="inline-flex items-center gap-2 px-3 py-2 text-xs font-bold uppercase tracking-[0.08em]"
                            style={{ background: 'var(--brand)', color: '#fff', borderRadius: 2 }}>
                        <Plus size={14} weight="bold" />Nový uživatel
                    </button>
                }
            />
            <Card>
                <table className="w-full text-sm">
                    <thead>
                        <tr className="text-[10px] uppercase tracking-[0.1em]"
                            style={{ color: 'var(--text-secondary)' }}>
                            <th className="text-left py-2">E-mail</th>
                            <th className="text-left">Jméno</th>
                            <th className="text-left">Role</th>
                            <th className="text-center">Stav</th>
                            <th className="text-right">Akce</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((u) => (
                            <tr key={u.id} className="border-t" style={{ borderColor: 'var(--border-default)' }}>
                                <td className="py-2 font-mono text-xs">{u.email}</td>
                                <td>{u.name}</td>
                                <td className="font-mono text-xs">{u.roles.join(', ')}</td>
                                <td className="text-center">
                                    <StatusPill status={u.is_active ? 'success' : 'neutral'}
                                                label={u.is_active ? 'aktivní' : 'vypnutý'} />
                                </td>
                                <td className="text-right">
                                    <button onClick={() => del(u.id)} className="p-1 hover:bg-[var(--bg-surface-hover)]"
                                            data-testid={`user-delete-${u.id}`}>
                                        <Trash size={14} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Card>

            {editing && (
                <Modal title="Nový uživatel" onClose={() => setEditing(null)}>
                    <form onSubmit={save} className="grid grid-cols-2 gap-3">
                        <Field label="E-mail" value={editing.email}
                               onChange={(v) => setEditing({ ...editing, email: v })} required type="email" mono />
                        <Field label="Jméno" value={editing.name}
                               onChange={(v) => setEditing({ ...editing, name: v })} required />
                        <Field label="Heslo (min 8 znaků)" value={editing.password}
                               onChange={(v) => setEditing({ ...editing, password: v })} required type="password" mono />
                        <div>
                            <label className="text-[10px] uppercase tracking-[0.1em] font-bold"
                                   style={{ color: 'var(--text-secondary)' }}>Role</label>
                            <div className="mt-1 space-y-1">
                                {ROLES.map((r) => (
                                    <label key={r} className="block text-sm">
                                        <input type="checkbox"
                                               checked={editing.roles.includes(r)}
                                               onChange={(e) => {
                                                   const next = e.target.checked
                                                       ? [...editing.roles, r]
                                                       : editing.roles.filter((x) => x !== r);
                                                   setEditing({ ...editing, roles: next });
                                               }} /> {r}
                                    </label>
                                ))}
                            </div>
                        </div>
                        <div className="col-span-2 flex justify-end gap-2 mt-3">
                            <button type="button" onClick={() => setEditing(null)}
                                    className="px-3 py-2 text-xs font-bold uppercase border"
                                    style={{ borderColor: 'var(--border-default)', borderRadius: 2 }}>Zrušit</button>
                            <button type="submit"
                                    className="px-3 py-2 text-xs font-bold uppercase"
                                    style={{ background: 'var(--brand)', color: '#fff', borderRadius: 2 }}>Vytvořit</button>
                        </div>
                    </form>
                </Modal>
            )}
        </>
    );
};

export default Users;
